import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-items: start;
  padding: 1rem;
  gap: 1rem;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
`
